import {METERS_PER_KM2} from '@app/util/conversions.js';

export const getMinimumSQMCost = product => {
  if (!product.area || product.area?.op !== 'gte') {
    return 0;
  }

  if (product.area.units === 'sqkm') {
    return product.area.value * METERS_PER_KM2;
  }

  if (product.area.units === 'sqm') {
    return product.area.value;
  }

  return 0;
};
